export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const CLEANUP = 'CLEANUP'
export const SET_IS_CHECKED = 'SET_IS_CHECKED'
export const SET_NEXT_PATH = 'SET_NEXT_PATH'
